// extracted by mini-css-extract-plugin
export var readonly = "_hc-1";
export var star = "_hc-0";